import React from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import useRegisterService from 'src/Common/Registerservice'
import 'src/Pages/StudentPages/login/login.scss'
import 'src/Pages/StudentPages/register/register.scss'
import logo from 'src/assets/images/1journey.png'
import art from 'src/assets/images/readingbook.png'

const ArrowIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
)

const Register = () => {
  const {
    formData,
    formDataError,
    isLoading,
    handleSubmit,
    handleChange,
    handleRoleDropdownChange,
  } = useRegisterService()
  const onSubmit = async (e) => {
    try {
      const success = await handleSubmit(e)
      if (success) {
        toast.success('Registration Successful! Confirmation email sent to you', {
          autoClose: 5000,
          style: { background: 'lightgreen', color: 'white' },
        })
      }
    } catch (error) {
      toast.error(error.message || 'Registration Error', {
        autoClose: 5000,
        style: { background: 'lightcoral', color: 'white' },
      })
    }
  }

  return (
    <div className="jl">
      <ToastContainer />
      <div className="jl__shell">
        <aside className="jl__hero jl__hero--art">
          <div className="jl__aurora" aria-hidden="true">
            <span className="jl__orb jl__orb--a" />
            <span className="jl__orb jl__orb--b" />
            <span className="jl__orb jl__orb--c" />
            <span className="jl__beam" />
            <span className="jl__grid" />
          </div>

          <div className="jl__art">
            <span className="jl__art-glow" aria-hidden="true" />
            <img src={art} alt="A student reading" className="jl__art-img" />
            <div className="jl__art-tag">
              <span>1Journey</span>
              <strong>Stay with us</strong>
            </div>
          </div>
        </aside>

        <main className="jl__panel">
          <div className="reg__card">
            <img src={logo} alt="1Journey" className="reg__card-logo" />
            <span className="jl__eyebrow">Get started</span>
            <h2 className="jl__title">Create your account</h2>
            <p className="jl__sub">Register as a tutor, counselor, or mentor.</p>

            <form onSubmit={onSubmit} noValidate>
              <div className="reg__field">
                <label htmlFor="role">Role</label>
                <select
                  id="role"
                  name="role"
                  className="reg__select"
                  value={formData.role}
                  onChange={handleRoleDropdownChange}
                >
                  <option value="">Select role</option>
                  <option value="Tutor">Tutor</option>
                  <option value="Counselor">Counselor</option>
                  <option value="Mentor">Mentor</option>
                </select>
                {formDataError.roleError && (
                  <span className="reg__err">{formDataError.roleError}</span>
                )}
              </div>

              <div className="reg__grid">
                <div className="reg__field">
                  <label htmlFor="firstName">First name</label>
                  <input
                    id="firstName"
                    className={`reg__input${
                      formDataError.firstNameError ? ' reg__input--err' : ''
                    }`}
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="First name"
                  />
                  {formDataError.firstNameError && (
                    <span className="reg__err">{formDataError.firstNameError}</span>
                  )}
                </div>
                <div className="reg__field">
                  <label htmlFor="middleName">
                    Middle name{' '}
                    <span style={{ color: 'var(--muted)', fontWeight: 400 }}>(optional)</span>
                  </label>
                  <input
                    id="middleName"
                    className="reg__input"
                    name="middleName"
                    value={formData.middleName}
                    onChange={handleChange}
                    placeholder="Middle name"
                  />
                </div>
              </div>

              <div className="reg__grid">
                <div className="reg__field">
                  <label htmlFor="lastName">Last name</label>
                  <input
                    id="lastName"
                    className={`reg__input${formDataError.lastNameError ? ' reg__input--err' : ''}`}
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Last name"
                  />
                  {formDataError.lastNameError && (
                    <span className="reg__err">{formDataError.lastNameError}</span>
                  )}
                </div>
                <div className="reg__field">
                  <label htmlFor="email">Email</label>
                  <input
                    id="email"
                    type="email"
                    className={`reg__input${formDataError.emailError ? ' reg__input--err' : ''}`}
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="you@email.com"
                  />
                  {formDataError.emailError && (
                    <span className="reg__err">{formDataError.emailError}</span>
                  )}
                </div>
              </div>

              <button type="submit" className="jl__btn reg__btn" disabled={isLoading}>
                {isLoading ? (
                  <>
                    <span className="jl__spinner" aria-hidden="true" /> Creating account&hellip;
                  </>
                ) : (
                  <>
                    Create account <ArrowIcon />
                  </>
                )}
              </button>
            </form>
          </div>
        </main>
      </div>
    </div>
  )
}

export default Register
